/**
 * Sep-design PDP gallery videos play in the fancybox video player.
 *
 * Inline playback inside the main Swiper does not start on iOS Safari: tapping the
 * Plyr play button in the middle of the video slide does nothing. Tapping the play
 * button (or the video before it has started) opens the video in fancybox instead,
 * the same lightbox gallery images open in.
 *
 * Opens from touchend on touch devices (iOS sends no click for the tap) and from click
 * otherwise. Listens in the capture phase so Plyr and Swiper never see the tap. Delegated from
 * document because mobile hoists .mainslider-wrapper out of the gallery root and the
 * storefront renderer swaps gallery markup after load.
 */
;(function () {
  if (window.__sepGalleryVideoLightbox) return
  window.__sepGalleryVideoLightbox = true

  // Mobile: full-width video, dropping fancybox's 44px side gutters (keep top room for the close button)
  const style = document.createElement('style')
  style.textContent =
    '.sep-video-lightbox .fancybox-slide--video .fancybox-content{background:transparent}' +
    '@media (max-width:797px){.sep-video-lightbox .fancybox-slide--video{padding:44px 0}}'
  document.head.appendChild(style)

  function videoFromTap(target) {
    if (!target || !target.closest) return null
    const container = target.closest('.mainslider-wrapper [data-html5-video]')
    if (!container) return null
    const video = container.querySelector('video')
    if (!video) return null
    const plyr = container.querySelector('.plyr')
    if (plyr) {
      // Big play button, or the poster before playback has ever started
      if (target.closest('.plyr__control--overlaid')) return video
      if (plyr.classList.contains('plyr--stopped') && !target.closest('.plyr__controls')) return video
      return null
    }
    // Storefront-rendered slides use native controls (Plyr only sets up at page load)
    return video.paused && video.currentTime === 0 ? video : null
  }

  function sourceOf(video) {
    const source = video.querySelector('source[type="video/mp4"]') || video.querySelector('source')
    return {
      src: video.currentSrc || (source && source.src) || video.src || '',
      format: (source && source.getAttribute('type')) || 'video/mp4'
    }
  }

  // Metadata is often not loaded yet (iOS ignores preload), so fall back to the gallery slide's shape
  function aspectOf(video) {
    if (video.videoWidth && video.videoHeight) return video.videoWidth / video.videoHeight
    const box = (video.closest('.plyr') || video).getBoundingClientRect()
    return box.width && box.height ? box.width / box.height : 16 / 9
  }

  function openLightbox(video) {
    const $ = window.jQuery
    if (!$ || !$.fancybox) return false
    if ($.fancybox.getInstance()) return true
    const { src, format } = sourceOf(video)
    if (!src) return false
    video.pause()

    $.fancybox.open(
      {
        src,
        type: 'video',
        opts: {
          videoFormat: format,
          thumb: video.getAttribute('poster') || '',
          ratio: aspectOf(video)
        }
      },
      {
        baseClass: 'sep-video-lightbox',
        hash: false,
        loop: false,
        infobar: false,
        buttons: ['close'],
        video: {
          tpl:
            '<video class="fancybox-video" controls playsinline controlsList="nodownload" poster="{{poster}}">' +
            '<source src="{{src}}" type="{{format}}" /></video>',
          autoStart: true
        }
      }
    )

    // Start within the tap so iOS allows playback with sound
    const lightboxVideo = document.querySelector('.fancybox-slide--current video.fancybox-video')
    if (lightboxVideo) {
      const played = lightboxVideo.play()
      if (played && typeof played.catch === 'function') played.catch(() => {})
    }
    return true
  }

  // iOS Safari never delivers a click for a tap on the gallery video (the original bug), so
  // open from the touch itself. preventDefault on touchend cancels any click that would follow.
  let touchStart = null
  document.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0]
      touchStart =
        event.touches.length === 1 && videoFromTap(event.target) ? { x: touch.clientX, y: touch.clientY } : null
    },
    { capture: true, passive: true }
  )
  document.addEventListener(
    'touchend',
    (event) => {
      if (!touchStart) return
      const touch = event.changedTouches[0]
      const moved = Math.abs(touch.clientX - touchStart.x) + Math.abs(touch.clientY - touchStart.y)
      touchStart = null
      // A swipe through the gallery, not a tap
      if (moved > 10) return
      const video = videoFromTap(event.target)
      if (!video || !openLightbox(video)) return
      event.preventDefault()
      event.stopPropagation()
    },
    { capture: true, passive: false }
  )

  // Mouse and keyboard
  document.addEventListener(
    'click',
    (event) => {
      const video = videoFromTap(event.target)
      if (!video || !openLightbox(video)) return
      event.preventDefault()
      event.stopPropagation()
    },
    true
  )
})()
